import './Loader.scss';

import React from 'react';

import { useTheme } from '../../../context/ThemeProvider';

export interface DotsFlashingLoaderProps {
  color?: string;
  size?: number;
  speed?: number; // in milliseconds
  style?: React.CSSProperties;
}

const DotsFlashingLoader: React.FC<DotsFlashingLoaderProps> = (props) => {
  const { colors: COLORS } = useTheme();

  const {
    color = COLORS.PRIMARY,
    size = 6,
    speed = 500, // default speed is 500ms
    style,
  } = props;

  return (
    <div
      className="dots-flashing__loader"
      style={
        {
          '--color': color,
          '--size': `${size}px`,
          '--speed': `${speed}ms`,
          ...style,
        } as React.CSSProperties
      }>
      <span className="dots-flashing__loader__dot" />
      <span className="dots-flashing__loader__dot" />
      <span className="dots-flashing__loader__dot" />
    </div>
  );
};

export default DotsFlashingLoader;
